import DialogComponent from "components/Dialog";

export default class CreateSectionDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogFor: "general",
            info: false,
            mode: "create",
        };
    }

    title = "price.createSection";

    show(mode, info, hidCb) {
        this.dialogTitle = `price.${mode === "create" ? "createSection" : "editSection"}`;
        this.state.info = info;
        this.state.mode = mode;
        this.hidCb = hidCb;
        super.show();
    }

    onShow() {
    }

    async save() {
        const { mode, info } = this.state;
        const { rootId, priceListId, sectionsId } = info;
        const tempId = this._helper.number.generateUniqueID();

        if (mode === "create" && (!this.inputNumber.value || +this.inputNumber.value === 0))
            return this.showError("price.cannotBeEmpty", "price.sectionNumber");

        if (mode === "create" && sectionsId.includes(+this.inputNumber.value))
            return this.showError("price.numberIsNotUnique", "price.sectionNumber");

        if (mode === "create") {
            const template = {
                domainId: 345,
                linkId: 0,
                historyId: 373,
                value: 0,
                rating: 0,
                typeId: 0,
                linkIdList: null,
                altCode: null,
                noDiscount: false,
                priceListId: priceListId,
                items: [],
                name: this.inputName.value,
                parentId: rootId,
                code: +this.inputNumber.value,
                tempId: tempId,
            };

            if (this.hidCb?.apply)
                this.hidCb(template);


        } else {
            const template = {
                ...info.info,
                name: this.inputName.value,
                code: +this.inputNumber.value,
            };

            if (this.hidCb?.apply)
                this.hidCb(template);
        }

        this.hide();

    }

    renderContent() {

        const { info, mode } = this.state;
        const { sectionsId } = info;
        const code = (sectionsId.length === 0) ? 1 : Math.ceil((Math.max(...sectionsId) + 0.1) / 10) * 10;

        return (
            <div className="content flex col gap16">
                <div>{this.insertRowInfo("price.sectionNumberName", "")}</div>
                <div className="flex gap16">
                    <div style={{ flex: "0.2" }}>
                        {this.insertInput({
                            ref: el => this.inputNumber = el,
                            type: "number",
                            placeHolder: "0",
                            value: mode === "create" ? code : info.number,
                        })}
                    </div>
                    <div className="flex1">
                        {this.insertInput({
                            ref: el => this.inputName = el,
                            placeHolder: "price.newSection",
                            value: info.name,
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

